import { useContext, type ComponentProps } from 'react';
import { ThemeContext } from 'styled-components';
import SmartphoneIcon from './SmartphoneIcon';

/** Smartphone glyph for a call that has both a primary and a secondary location. */
export default function AssociatedSmartphoneIcon(
  props: ComponentProps<typeof SmartphoneIcon>,
) {
  const theme = useContext(ThemeContext);
  return <SmartphoneIcon {...props} color={theme?.colors?.lightWarning} />;
}
